import React from "react";
import {IoMdSearch} from "react-icons/io";

export default function SearchIcon(props) {
    return <IoMdSearch {...props} />;
}
